import React from 'react'
import { withTheme } from 'react-jss'
import { withTranslation } from 'react-i18next'
import compose from '@shopify/react-compose'

import { ContentBox } from '@portal/kit/pkg/components'
import Catalog from "./catalog"

import catalogStyle from './catalog-style'

const CatalogListView = ({ catalogs, theme, t, disabledMessagesKeys }) => {
  const classes = catalogStyle(theme)
  const length = catalogs.length

  return (
    <div className={classes.container}>
      {catalogs.map((catalog, index) => {
        const disabled = disabledMessagesKeys[catalog.internal_name]

        return (
          <ContentBox
            key={catalog.id}
            className={classes.box}
            title={(length > 1 && index === 0) ? t('offers.discover_options') : null}>
            <Catalog
              defaultOpened={!disabled && index === 0}
              className={classes.catalog}
              catalog={catalog}
              disabledMessage={disabled ? t(disabledMessagesKeys[catalog.internal_name]) : null}
            />
          </ContentBox>
        )
      }
      )}
    </div>
  )
}

export default compose(
  withTheme,
  withTranslation()
)(CatalogListView)
